import { useState } from "react";

export interface PublicRewardFilters {
  readonly text: string;
}

export const usePublicRewardsSearch = () => {
  const [publicRewardsSearch, setPublicRewardsSearch] = useState<PublicRewardFilters>({
    text: "",
  });
  return { publicRewardsSearch, setPublicRewardsSearch };
};
